module.exports = __webpack_public_path__ + "img/car-21.12589875.jpg";